<template>
  <lay-row style="width: 1880px; ">
    <lay-col md="6">
      <div style="padding: 10px;">
        <lay-quote v-if="false">
          <span>统计时间选择：</span>
          <lay-date-picker v-model="date" static simple type="yearmonth" allowClear  style="width: 100%;margin-top: 10px"></lay-date-picker>
        </lay-quote>
        <lay-card title="配电室">
          <template #title>
            <lay-row style="margin-top: 10px" :space="5">
              <lay-col md="12">
                <lay-input prefix-icon="layui-icon-search"   v-model="keyWorld" placeholder="输入搜索编号或柜体名称" @input="change"></lay-input>
              </lay-col>
              <lay-col md="12">
                <lay-date-picker simple type="yearmonth" v-model="searchDate" placeholder="选择搜索时间" allow-clear @change="loadKw(current_node_id , nodeName)"></lay-date-picker>
              </lay-col>
            </lay-row>
          </template>
          <lay-space :size="10" align="start">
            <lay-tab :type="'brief'" v-model="curTab" :tabPosition = "'left'" style="height: 700px;width: 90px" @change="change">
              <lay-tab-item id="0">
                <template #title>
                  <lay-icon type="layui-icon-chart"></lay-icon>1ES
                </template>
              </lay-tab-item>
              <lay-tab-item id="1">
                <template #title>
                  <lay-icon type="layui-icon-chart"></lay-icon>2ES
                </template>
              </lay-tab-item>
              <lay-tab-item id="2">
                <template #title>
                  <lay-icon type="layui-icon-chart"></lay-icon>3ES
                </template>
              </lay-tab-item>
              <lay-tab-item id="3">
                <template #title>
                  <lay-icon type="layui-icon-chart"></lay-icon>4ES
                </template>
              </lay-tab-item>
            </lay-tab>
            <lay-table :columns="columns" :data-source="DB_ES" even style="width: 310px" height="650px">
              <template #operator="{row}">
                <lay-button border="green" border-style="dashed" size="xs" @click="loadKw(current_node_id = row.id, row.name)">
                  查看<lay-icon type="layui-icon-chart"></lay-icon>
                </lay-button>
              </template>
            </lay-table>
          </lay-space>
        </lay-card>
      </div>
    </lay-col>
    <lay-col md="18" id="chart">
    </lay-col>
  </lay-row>
  <teleport to="#chart">
    <div style="padding: 10px;">
      <lay-row>
        <lay-col md="6">
          <span>统计信息：{{(DB_ESS?.[curTab]?.line ?? '') + '-' + (nodeName ?? '')}}</span>
        </lay-col>
        <lay-col md="12">
          <div style="text-align: center">
            <lay-radio-group v-model="selectedType">
              <lay-radio-button size="xs" value="0">柱状图</lay-radio-button>
              <lay-radio-button size="xs" value="1">数据表格</lay-radio-button>
            </lay-radio-group>
          </div>
        </lay-col>
      </lay-row>
      <div style="padding:20px 50px">
        <lay-col md="24">
          <div >
            <lay-card>
              <template v-slot:body>
                <v-chart ref="vchart" class="chart" :option="option" v-show="selectedType == 0"></v-chart>
                <lay-table :columns="kwhColumns" :data-source="monitorData" even style="width: 100%" height="650px" v-show="selectedType == 1">
                </lay-table>
              </template>
            </lay-card>
          </div>
        </lay-col>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import {inject, onMounted, ref, shallowRef} from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  ToolboxComponent,
  GraphicComponent, MarkPointComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import axios from "axios";
import {layer} from "@layui/layui-vue";
import {debounce} from "lodash";

let seconds = inject('seconds')
const date = ref(new Date())
const curTab = ref('0')
const DB_ESS = shallowRef([])
const DB_ES = shallowRef([])
const keyWorld = ref('')
const searchDate = ref(seconds.value.split(' ')[0])
let current_node_id = 359
let nodeName = ref()
let selectedType = ref('0')

function loadKw(node_id, name){
  if (!node_id) return;
  let dt = searchDate.value ?? '';
  nodeName.value = name;
  if (dt.length == 7) dt = dt + '-01';
  axios.get(`/kwh?node_id=${node_id}&date=` + dt)
      .then(function (response) {
        if (response.data.code == 0){
          service(response.data.data)
        }
      })
}

function loadInfo(){
  axios.get(`/info`)
      .then(function (response) {
        if (response.data.code == 0){
          console.log(response.data.data)
          DB_ESS.value = response.data.data;
          DB_ES.value = DB_ESS.value[curTab.value]['nodeList'];
        }
      })
}


onMounted(() => {
  loadInfo();
  loadKw()
  setTimeout(() =>   layer.msg("请选择需要查看的数据节点", { time: 2000}), 100)
})



function generateFilterData(){
  DB_ES.value = DB_ESS.value[curTab.value]['nodeList'].filter(v => v.cabinet_no.indexOf(keyWorld.value) != -1 || v.name.indexOf(keyWorld.value) != -1)
}

const change = debounce(generateFilterData, 300, {maxWait: 2000});

const columns = [
  {
    title:"编号",
    width:"50px",
    key:"cabinet_no",
    ellipsisTooltip: true,
  },
  {
    title:"柜体名称",
    width:"80px",
    key:"name",
    ellipsisTooltip: true,
  },
  {
    title:"操作",
    width:"30px",
    customSlot: "operator",
    key: "operator",
  }
]
const monitorData = ref([])

const kwhColumns = [
  {
    title:"日期",
    width:"50px",
    key:"key",
    ellipsisTooltip: true,
    totalRow: '汇总',
  },
  {
    title:"采集开始",
    children: [
      { title: "时间", key: "baseTime", width: "70px",ellipsisTooltip: true, },
      { title: "底数(kW·h)", key: "base", width: "70px",ellipsisTooltip: true, },
    ],
  },
  {
    title:"采集结束",
    children: [
      { title: "时间", key: "currentTime", width: "70px",ellipsisTooltip: true, },
      { title: "底数(kW·h)", key: "current", width: "70px",ellipsisTooltip: true, },
    ]
  },
  {
    title:"当前日期用电量(kW·h)",
    width:"70px",
    key:"value",
    ellipsisTooltip: true,
    totalRow: true,
    sort: true
  },
]
use([CanvasRenderer, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, ToolboxComponent, BarChart, GraphicComponent, MarkPointComponent]);
const vchart = ref()
// const dataSource = ref([]);
// const node = ref([])



function service(data){
  if (vchart.value){
    monitorData.value.length = 0;
    monitorData.value.push(...data)
    setTimeout(renewChart, 500)
  }
}

function renewChart(){
  layer.closeAll();
  let innerOption = vchart.value.getOption();
  let configs = series_configs();
  for (let i = 0 ; i < configs.length ; i++){
    innerOption.series[i].data = configs[i].data;
  }
  innerOption.xAxis[0].data = (() => {
    let _data = []
    for (let d of monitorData.value){
      _data.push(d['key'])
    }
    return _data;
  })()
  vchart.value.setOption(innerOption, true)

}





const realtime_series_config = (name, color, data, /*fieldName = undefined*/) => {
  return {
    name: name,
    type: 'bar',
    symbol: 'none',
    sampling: 'lttb',
    itemStyle: {
      color: color
    },
    markPoint: {
      data: [
        {type: 'max', name: '最大值', symbolSize: 30,  label: {offset: [0, -25], formatter: '{b}\n{c}kW·h'}},
        {type: 'min', name: '最小值', symbolSize: 30, symbolRotate: '0', label: {offset: [0, -25], formatter: '{b}\n{c}kW·h'}, itemStyle: {color: '#ff4d4f'}}
      ],
      // itemStyle: {
      //   color: '#ff4d4f', // 标记点填充颜色
      //   borderWidth: 2
      // },
      // label: {
      //   color: '#fff', // 标记点文字颜色
      // }
    },
    data: (() => {
      let _data = []
      for (let d of data){
        if (d.base && (d.baseTime != d.currentTime)){
          _data.push(d) //[fieldName ?? name]
        }
      }
      return _data;
    })()
  }
}

const option = {
  title: {
    text: "",
    left: "left"
  },
  tooltip: {
    trigger: 'axis',
    position: function (pt) {
      return [pt[0], '10%'];
    },
    formatter: (params) => {
      let tip = '';
      if (params && params.length > 0) {
        tip += params[0].name + '<br />';
        params.forEach(item => {
          tip += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(5,75,87);"></span>' + item.data.currentTime + ' ' + (item.data.current ? item.data.current + 'kW·h' : '-') + '<br />';

          tip += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(5,75,87);"></span>' + item.data.baseTime + ' ' + (item.data.base ? item.data.base + 'kW·h' : '-') + '<br />';

          tip += item.marker + item.seriesName + ' ' + (item.value ? item.value + 'kW·h' : '-') + '<br />';
        });
      }
      return tip;
    }
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: [],
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%']
  },
  toolbox: {
    feature: {
      // dataZoom: {
      //   yAxisIndex: 'none'
      // },
      // restore: {},
      saveAsImage: {
        name
      }
    }
  },
  dataZoom: [{
    type: 'inside',
    start: 0,
    end: 100
  }, {
    start: 0,
    end: 10
  }],
  series: series_configs(),
  // graphic: {
  //   type: 'text',
  //   left: "center",
  //   top: "center",
  //   style: {
  //     text: !(monitorData.value?.length) ? '请选择需要查看的数据节点' : '',
  //     font: '16px "STHeiti", sans-serif',
  //     fill: 'rgb(30, 159, 255)'
  //   }
  // }
};

function series_configs(){
  return [
    realtime_series_config('用电量', 'rgb(30, 159, 255)', monitorData.value, 'value'),
  ]
}


</script>

<style scoped>

</style>